<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-row class="mx-2 my-1">
        <v-col cols="12" md="8">
          <v-row>
          </v-row>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";

export default {
  name: "Home",

  components: {
    Breadcrumbs,
  },

  data: () => ({

  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: true,
        href: "/home",
      },
    ],
  },

  mounted() {

  },

  methods: {

  },
};
</script>
